import { React, useState, useContext, useEffect } from 'react'
import { FaChevronDown, FaChevronRight, FaEdit } from "react-icons/fa";
import { FormGroup, Col, Label, Input, Form, Row, NavLink, ListInlineItem, Dropdown, DropdownToggle, DropdownMenu, DropdownItem,Table } from 'reactstrap'
import SubHeader from './SubHeader';
import { GlobalContext } from '../../App';
import TopHeader from './TopHeader';
import { BsChevronRight } from "react-icons/bs";
import { toast } from 'react-toastify';
import axios from '../../api/axios';
import Select from 'react-select';
import { InfinitySpin } from "react-loader-spinner";
import { useNavigate, useLocation } from "react-router-dom";
function AddDepartment() {
    const navigate = useNavigate();
    const location = useLocation();
    const { pathname } = location;
    const [modal, setModal] = useState(false);
    const [isFilter, setIsFilter] = useState(false);
    const [departmentName, setDepartmentName] = useState("");
    const [departmentDesc, setDepartmentDesc] = useState("");
    const [isActive, setIsActive] = useState("1");
    const { rolexModuleData, roles, user_id } = useContext(GlobalContext);
    const [departmentData, setDepartmentData] = useState("");
    const [updateId, setUpdateId] = useState("");
    const [companyId, setCompanyId] = useState("");
    const [buId, setBuId] = useState("");
    const [companyList, setCompanyList] = useState([]);
    const [buList, setBuList] = useState([]);
    const [productisOpen1, productsetIsOpen1] = useState(1);
    const [companyFilter, setCompanyFilter] = useState();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen((prevState) => !prevState);
    const [loading, setLoading] = useState(true); 
     // Handle Error
  const handleError = (error) => {
    setLoading(false);
    const statusCode = error.response ? error.response.status : null;
    let errorMessage = "An error occurred!";

    if (statusCode === 500) {
      errorMessage = "Internal Server Error!";
    } else if (statusCode === 404) {
      errorMessage = "Page Not Found!";
    }

    toast.error(errorMessage, {
      position: toast.POSITION.TOP_RIGHT,
      theme: "colored",
      autoClose: 2000,
    });
  };
    // ----------------------------------------------------------- Handle Close ---------------------------------------
    const handleClose = () => {
        setModal(false);
        setIsFilter(false);
        setDepartmentName('');
        setDepartmentDesc('');
        setUpdateId('');
        setIsActive('1');
        setCompanyId('');
        setBuId('');
    }
    // Modal State Change
    const toggleModal = () => {
        setIsFilter(false);
        setModal(!modal);
    }
    // Filter Data
    const toggleFilter = () => {
        setIsFilter(true);
        setModal(!modal);

    }
    // Post Department Data
    const postDepartmentData = (e) => {
        e.preventDefault();
        if (departmentName === null || departmentName === "") {
            toast.error("Department Name is required!", {
                position: toast.POSITION.TOP_RIGHT,
                theme: "colored",
                autoClose: 2000
            });
        }
        // else if (departmentName == null || departmentName == "") {
        //     toast.error("Department Name is required!", {
        //         position: toast.POSITION.TOP_RIGHT,
        //         theme: "colored",
        //         autoClose: 2000
        //     });
        // }
        else if (departmentDesc === null || departmentDesc === "") {
            toast.error("Department Description is required!", {
                position: toast.POSITION.TOP_RIGHT,
                theme: "colored",
                autoClose: 2000
            });
        }
        else {
            const params = {
                companyId: companyId,
                BUId:buId,
                departmentName: departmentName,
                departmentDesc: departmentDesc,
                isActive: isActive,
                user_id: user_id,
                updateId: updateId
            }
            axios.post('/postDepartmentData', params).then((response) => {
                if (response?.status === 202) {
                    toast.error("Department Name Already Exist!", {
                        position: toast.POSITION.TOP_RIGHT,
                        theme: "colored",
                        autoClose: 2000
                    });
                }
                else {
                    toast.success(`Department ${updateId ? "Updated" : "Insert"} Successfully!`, {
                        position: toast.POSITION.TOP_RIGHT,
                        theme: "colored",
                        autoClose: 2000
                    });
                    handleClose();
                    getCompBuDeptData();
                }
            }
            ).catch(handleError);
        }
    }

    // get Company Data
    const getCompBuDeptData = () => {
        setLoading(true);
        axios.get('/getCompBuDeptData').then((response) => {
            setDepartmentData(response?.data?.[0]?.company_data);
            const companyList = response?.data?.[0]?.company_data?.filter((item)=> item?.bu_data)?.map((item) => ({ label: item?.company_name, value: item?.company_id })) ?? [];
            setCompanyList(companyList);
            setCompanyFilter(companyList?.[0]);
            setLoading(false);
        }).catch(handleError);
    }
    // Company Update
    const departmentUpt = (company_id, bu_id,department_id) => {
        const companyData = departmentData?.find((data) => data?.company_id === company_id)?.bu_data;
        const buItem = companyData?.find((item) => item?.bu_id === bu_id)?.department_data;
        const departmentItem = buItem?.find((item) => item?.department_id === department_id);
        if (departmentItem) {
            setDepartmentName(departmentItem.department_name);
            setDepartmentDesc(departmentItem.department_description);
            setIsActive(departmentItem.isActive);
            setUpdateId(department_id);
            setCompanyId({ label: departmentData?.find((data) => data?.company_id === company_id)?.company_name, value: company_id });
           setBuId({label : companyData?.find((item) => item?.bu_id === bu_id)?.bu_name , value : bu_id })
            setModal(true);
        }
    };

    const manageBuList = (select) =>{
        setCompanyId(select);
        const BuList = departmentData?.filter((data)=> data?.company_id === select?.value)?.[0]?.bu_data?.map((data)=>({label : data?.bu_name ,value: data?.bu_id}));
        setBuList(BuList)
    }
    // -------------------------------------------------------- Use Effect -----------------------------------------
    useEffect(() => {
        getCompBuDeptData();
    }, []);
    const departmentContent = <Form name="personal-info-details" className='modelform' >
        <Row>
            <Col md={12}>
                <FormGroup>
                    <Label htmlFor="companyName">
                        Company Name*
                    </Label>
                    <Select
                        classNamePrefix="react-select"
                        className="multi-select"
                        menuPlacement="auto"
                        maxMenuHeight={200}
                        onChange={(select) =>manageBuList(select) }
                        options={companyList}
                        value={companyId || ""}
                        isDisabled={updateId}
                        // {...props}
                        theme={theme => ({
                            ...theme,
                            colors: {
                                ...theme.colors,
                                primary25: 'rgba(2, 137, 255,.2)',
                                primary50: 'rgba(2, 137, 255,.2)',
                                primary75: 'rgba(2, 137, 255,.2)',
                                primary: '#0289ff',
                            }
                        })}
                    />
                </FormGroup>
            </Col>
            <Col md={12}>
                <FormGroup>
                    <Label htmlFor="companyName">
                        Business Unit Name*
                    </Label>
                    <Select
                        classNamePrefix="react-select"
                        className="multi-select"
                        menuPlacement="auto"
                        maxMenuHeight={200}
                        onChange={(select) => setBuId(select)}
                        options={buList}
                        value={buId || ""}
                        isDisabled={updateId}
                        // {...props}
                        theme={theme => ({
                            ...theme,
                            colors: {
                                ...theme.colors,
                                primary25: 'rgba(2, 137, 255,.2)',
                                primary50: 'rgba(2, 137, 255,.2)',
                                primary75: 'rgba(2, 137, 255,.2)',
                                primary: '#0289ff',
                            }
                        })}
                    />
                </FormGroup>
            </Col>
            <Col md={12}>
                <FormGroup>
                    <Label htmlFor="departmentName">
                        Department Name *
                    </Label>
                    <Input id="departmentName" name="departmentName" type="text" value={departmentName} placeholder='Department Name ' onChange={(e) => setDepartmentName(e.target.value)} />
                </FormGroup>
            </Col>
            <Col md={12}>
                <FormGroup>
                    <Label htmlFor="role_desc">
                        Description*
                    </Label>
                    <Input id="roleDesc" name="roleDesc" type="textarea" value={departmentDesc} placeholder='Department Description' onChange={(e) => setDepartmentDesc(e.target.value)} />
                </FormGroup>
            </Col>
            <Col md={12}>
                <FormGroup>
                    <Label htmlFor="role_desc">
                        Status:
                    </Label>
                    <div>
                        <div className="d-inline-block m-2"><input type="radio" id="isActive" name="status" value='1' checked={isActive === "1" ? true : false} onChange={(e) => setIsActive("1")} /> Active</div>
                        <div className="d-inline-block"><input type="radio" id="isInactive" name="status" value='0' checked={isActive === "1" ? false : true} onChange={(e) => setIsActive("0")} /> Inactive</div>
                    </div>
                </FormGroup>
            </Col>
        </Row>
    </Form>
    return (
        loading ? (
            <div className="loader">
            <InfinitySpin width="200" color="#D81159" />
          </div>
          ) :
        (<>
            <TopHeader
                breadCrumb={
                    <>
                        <li className="nav-item"><a onClick={() => navigate("/home")} className="nav-link">Home <BsChevronRight /></a></li>
                        <li className="nav-item"><span>Add Department</span></li>
                    </>
                } />
            <SubHeader
                SubHeaderTitle="Add Department"
                openSidebar={modal}
                isFilter={isFilter}
                handleClose={handleClose}
                toggleModal={toggleModal}
                toggleFilter={toggleFilter}
                handleSubmit={postDepartmentData}
                titleButton={`${updateId ?'Edit':'Add'} Department`}
                showButton={((rolexModuleData?.find((data) => pathname === data?.description && data?.create === 1)) || roles?.find((data) => data?.role_id === 1001)) ? true : false}
                AddUserContent={departmentContent}
                userStatus={
                    <ListInlineItem>
                      <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                        <DropdownToggle className='activeuser' caret>{companyFilter?.label || "Please Select Company Name"}</DropdownToggle>
                        <DropdownMenu >
                            {companyList?.length > 0 ? companyList?.map((data) =>(
                                <DropdownItem onClick={() => setCompanyFilter(data)}>{data?.label}</DropdownItem>
                            )): null}                          
                        </DropdownMenu>
                      </Dropdown>
                    </ListInlineItem>
                  } 
            />
            <div className='department-wrap'>
            <div className='managerole-wrap contentInnerWrap'>
                {departmentData?.length > 0 ? departmentData?.filter((item)=> item?.company_id === companyFilter?.value)?.[0]?.bu_data?.filter((data)=> data?.department_data)?.length > 0 ? departmentData?.filter((item)=> item?.company_id === companyFilter?.value)?.[0]?.bu_data?.filter((data)=> data?.department_data)?.map((item) => (
                    
                    <div className='managerole'>
                        <div className='dropdown' onClick={() => productsetIsOpen1(productisOpen1 === item?.bu_id ? 0 : item?.bu_id)} >
                            {productisOpen1 === item?.bu_id ? <FaChevronDown /> : <FaChevronRight />}
                            <span>{item?.bu_name}</span>
                        </div>
                        <div className='manage-table'>
                            <div className={productisOpen1 === item?.bu_id ? "product-list  productlist-open" : "product-list "}>
                                <Table striped responsive>
                                    <thead>
                                        <tr>
                                            <th style={{ width: "3" }}>Department ID</th>
                                            <th>Department Name</th>
                                            <th> Description</th>
                                            <th>Status</th>
                                            <th>Created on</th>
                                            <th>Updated on</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {item?.department_data?.map((data) => (
                                            <tr>
                                                <th scope="row">{data?.department_id}</th>
                                                <td>{data?.department_name}</td>
                                                <td>{data?.department_description}</td>
                                                <td>{data?.isActive === "1" ? "Active" : "Inactive"}</td>
                                                <td>{new Date(data?.createdDate?.split('T')?.[0])?.toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric' })}</td>
                                                <td>{new Date(data?.updatedDate?.split('T')?.[0])?.toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric' })}</td>
                                                <td>
                                                {((rolexModuleData?.find((data) => pathname === data?.description && data?.update === 1)) || roles?.find((data) => data?.role_id === 1001)) ?  <NavLink className='edit' onClick={() => departmentUpt(data?.company_id, data?.bu_id, data?.department_id)}><FaEdit /></NavLink> :  '-'}
                                                </td>
                                            </tr>
                                        ))}

                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                )) :<div className='emptydata'><p>There is no company data!</p></div>:<div className='emptydata'><p>There is no company data!</p></div>}
            </div>
            </div>
        </>)
    )
}

export default AddDepartment